import React from "react";
import "./Aboutus.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Bgimage from "../HomePage/Bgimagesection/Bgimage";
import Aboutusbanner from "./Aboutusbanner";
import AboutusImages from "./AboutusImages";
import Aboutusbgbanner from "./Aboutusbgbanner";
import Aboutusjourney from "./Aboutusjourney";

import FloatingContactButton from "../../components/ContactUs/FloatingContactButton";
import ScrollToTopButton from "../HomePage/Scrolltotop/ScrollToTopButton";
import FloatingWhatsappButton from "../../components/ContactUs/FloatingWhatsappButton";
import { Helmet } from "react-helmet-async";

function Aboutus() {
  return (
    <div style={{ background: "#181818" }}>
      <Helmet>
        <title>About Us | Digital Transformation & Tech Experts - Dwebbox</title>
        <meta
          name="description"
          content="Learn about Dwebbox, a premier software development agency dedicated to digital transformation. Meet our team of engineers and designers committed to your success."
        />
        <link rel="canonical" href="https://dwebbox.com/aboutus" />
        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://dwebbox.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "About Us",
                "item": "https://dwebbox.com/aboutus"
              }
            ]
          })}
        </script>
      </Helmet>
      <ScrollToTopButton />
      <FloatingContactButton />
      <FloatingWhatsappButton />
      <Navbar />
      <Aboutusbanner />
      <AboutusImages />
      <Aboutusjourney />
      <Aboutusbgbanner />
      <Bgimage />
      <Footer />
    </div>
  );
}

export default Aboutus;
